import { Redirect, useLocalSearchParams } from 'expo-router';

export default function LearnAiLegacyCourseRedirect() {
  const { id } = useLocalSearchParams<{ id?: string | string[] }>();
  const canonicalId = Array.isArray(id) ? id[0] : id;
  return <Redirect href={canonicalId ? `/learn/course/${encodeURIComponent(canonicalId)}` : '/learn/path/create'} />;
}
